import React from 'react';
import { BedIcon, ClipboardListIcon, LockIcon, MicroscopeIcon, SparklesIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Card, CardBody } from '../Card';
import { CtaButton } from '../CtaButton';
const STEPS = [{
  icon: ClipboardListIcon,
  day: 'Day 1',
  title: 'You arrive. We design your smile on your face.',
  body: "Records, full clinical examination, CBCT 3D scan, intraoral scan, and facial photographs. Before any implant is placed, your smile is designed digitally and approved on your own face."
}, {
  icon: MicroscopeIcon,
  day: 'Day 2',
  title: 'Guided surgery, planned in software before you land.',
  body: "Four to six implants placed through a printed surgical guide, never freehand. You leave the chair with a fixed provisional smile you wear for the rest of your trip"
}, {
  icon: BedIcon,
  day: 'Days 3 and 4',
  title: 'Rest, recovery, follow-up. Adjustments as needed.',
  body: "Daily clinical check-ins, post-op review, comfort, speech, and bite verification. Most patients describe Days 3 and 4 as the moment they stop rehearsing their smile and start to feel like themselves again."
}, {
  icon: SparklesIcon,
  day: 'Day 5',
  title: 'Final prosthesis delivered. You fly home smiling.',
  body: "Fit, esthetics, speech, and function are verified one last time. Your final prosthesis is delivered, and you fly home the same day with it already in place."
}];
export function Mechanism() {
  return <section className="w-full bg-white py-20 lg:py-28" data-id="element-104" data-mp="2bo45j9upenjs">
      <div className="mx-auto max-w-6xl px-6" data-id="element-105" data-mp="2gnqj5keg25t4">
        <SectionHeading eyebrow="Exactly what happens in those five days" title={<><span data-id="element-107" data-mp="2lhutmdmx4vyy">This is not &ldquo;teeth in a day.&rdquo; </span><span className="text-[#1F6E7B]" data-id="element-108" data-mp="2phlha8h5evz9">It is your final smile in 5 days.</span></>} data-id="element-106" data-mp="2lfqeezjkkajd">
          <p data-id="element-109" data-mp="2ugybxfe9h7ce">Pler Smile Dadeland built a four step protocol that price driven clinics and speed driven clinics cannot replicate. 
Surgery is performed under local anesthesia. You remain awake and fully numb in the surgical area, with no general anesthesia, no IV sedation, and no added recovery risk.</p>
        </SectionHeading>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4" data-id="element-110" data-mp="ufhzc24eahyx">
          {STEPS.map((step, i) => {
          const Icon = step.icon;
          return <Card key={step.day} className="h-full" data-id="element-111" data-mp="14cmmo59z8jhb" data-mpi={i}>
                <CardBody className="flex h-full flex-col" data-id="element-112" data-mp="14b1w0qqs9koq">
                  <div className="mb-5 flex items-center justify-between" data-id="element-113" data-mp="1i2zwyeacca9t">
                    <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#A9DFE9]/40 text-[#1F6E7B]" data-id="element-114" data-mp="1e2fzf9luv4n5"><Icon size={24} data-id="element-115" data-mp="1s1p7tn3tkugk" /></span>
                    <span className="text-sm font-bold uppercase tracking-wide text-[#26B3CA]" data-id="element-116" data-mp="1s1fepqnha76n">Step {i + 1}</span>
                  </div>
                  <div className="text-sm font-semibold uppercase tracking-wide text-[#1A1A2E]/60" data-id="element-117" data-mp="3ttamhv6m5rjl">{step.day}</div>
                  <h3 className="mt-1 text-xl font-bold text-[#1A1A2E]" data-id="element-118" data-mp="3ouh9s4z5i4kh">{step.title}</h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-[#1A1A2E]/80" data-id="element-119" data-mp="24c6reelhciju">{step.body}</p>
                </CardBody>
              </Card>;
        })}
        </div>

        <p className="mx-auto mt-8 max-w-3xl text-center text-sm italic leading-relaxed text-[#1A1A2E]/70" data-id="element-120" data-mp="29ahw6awx42v7">
          After you fly home, a virtual follow-up with the Dadeland team is scheduled at approximately
          four months. You remain a Pler Smile patient for the full three years of the guarantee.
        </p>

        <figure className="mx-auto mt-16 max-w-3xl text-center" data-id="element-121" data-mp="1qks4vxsd5z81">
          <blockquote className="text-2xl font-bold leading-snug text-[#1A1A2E] md:text-3xl" data-id="element-122" data-mp="1qmcynl6ute4u">
            “We offers the only smile that actually belongs on your face.”
          </blockquote>
        </figure>

        <div className="mx-auto mt-10 flex max-w-3xl items-start gap-3 rounded-2xl bg-[#A9DFE9]/25 p-6 text-[15px] leading-relaxed text-[#1A1A2E]/85" data-id="element-123" data-mp="1gmuhfcibw6gh">
          <LockIcon size={20} className="mt-0.5 shrink-0 text-[#1F6E7B]" data-id="element-124" data-mp="3b0vfhv620pfi" />
          <p data-id="element-125" data-mp="1aydoq4jvkxg3">
            Only <span className="font-semibold text-[#1A1A2E]" data-id="element-126" data-mp="1ayvv3u094s1q">10 new cases per month</span> access the
            <span className="font-semibold text-[#1A1A2E]" data-id="element-127" data-mp="16w92hqvrb33h"> 5-Day Smile Experience Program</span> in Dadeland.
            This limit is clinical, not commercial. Every case requires exclusive booking of the surgical team.
          </p>
        </div>

        <div className="mt-9 flex flex-col items-center" data-id="element-128" data-mp="wycsj2ek2e6y">
          <CtaButton label="Reserve My Free Consultation" data-id="element-129" data-mp="rzrn8okg54bn" />
          <p className="mt-3 text-sm font-medium text-[#1A1A2E]/70" data-id="element-130" data-mp="s1ch0byxsj8g">You can confirm eligibility before traveling.</p>
        </div>
      </div>
    </section>;
}